import { MacGyverAccessLevel } from '@/services/auth';

/** Selectable access levels — 'None' is expressed by deactivating a user instead. */
export const accessLevelOptions: { value: MacGyverAccessLevel; label: string }[] = [
    { value: 'Standard', label: 'Standard' },
    { value: 'Advanced', label: 'Advanced' },
    { value: 'Admin', label: 'Admin' },
];
